export * as THREE from 'three';

/**
 * Node materials, for anything WorldMask has to mask. The classic
 * THREE.Mesh*Material classes don't set `isNodeMaterial` — and `three/webgpu`
 * re-exports those very same classes — so only these explicit *NodeMaterial
 * variants survive WorldMask.applyToMaterial's node-material guard.
 */
export { MeshStandardNodeMaterial, MeshBasicNodeMaterial } from 'three/webgpu';

import { AppBridge } from '@/app';

export * from '@/camera';
export * from '@/controls';
export * from '@/trees';
export * from '@/lights';
export * from '@/sky';
export * from '@/renderer';
export * from '@/audio';

// Objects
export * from '@/objects/aimPoint';
export * from '@/objects/ballTrail';
export * from '@/objects/flagStick';
export * from '@/objects/golfBall';
export * from '@/objects/statsPanel';
export * from '@/objects/contactShadow';
export * from '@/objects/treeColliderDebug';

// XR / MR
export * from '@/xr/session';
export * from '@/xr/anchor';
export * from '@/xr/controls';
export * from '@/xr/handInput';
export * from '@/xr/worldMask';
export * from '@/xr/groundHud';
export * from '@/xr/hudText';
export * from '@/xr/wristMenu';
export * from '@/xr/actionMenu';
export * from '@/xr/skyDome';
export * from '@/xr/shotTv';
export * from '@/xr/infoPanel';
export * from '@/xr/panelRay';
export * from '@/xr/stickRepeat';
export * from '@/xr/calibrationStore';
export * from '@/xr/controllerRay';
export * from '@/xr/clubOverlay';
export * from '@/xr/swingControls';
export * from '@/xr/inputModality';
export * from '@/xr/roomBounds';
export * from '@/xr/courseMapPanel';
export * from '@/xr/scorecardPanel';
export * from '@/xr/teleportControls';

// Shaders
export * from '@/shaders';

// Courses
export * from '@/courses/game';
export * from '@/courses/loader';
export * from '@/courses/surfaces';
export * from '@/courses/player';

// Physics
export * from '@/physics/ballPhysics';
export * from '@/physics/groundPhysics';
export * from '@/physics/constants';
export * from '@/physics/swingModel';

// UI
export * from '@/ui';

// Utils
export * from '@/utils/units';
export * from '@/utils/data';
export * from '@/utils/shotPresets';

import '@/css/base.css';

export const app = new AppBridge();